import CRUDService from 'src/services/CRUDService';
import {College} from '../types/college';

class CollegeService extends CRUDService<College> {
  async getByUniversityIds(
    universityIds: string[],
    fields: string,
    otherData: {
      sort?:
        | 'alpha'
        | 'distance'
        | 'tuition'
        | 'average-net-price'
        | 'earnings'
        | 'acceptance-rate'
        | 'six-year-grad-rate'
        | 'forbes-ranking'
        | 'us-news-ranking';
    }
  ) {
    return this.index({
      'university-ids': universityIds.join(','),
      fields: fields,
      sort: otherData.sort,
    });
  }
}

export default new CollegeService('/v1/colleges');
